const validate = (rut) => {
    if (typeof rut !== "string") {
        return false;
    }

    // if it starts with 0 we return false
    // so a rut like 00000000-0 will not pass
    if (/^0+/.test(rut)) {
        return false;
    }

    if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(rut)) {
        return false;
    }

    rut = clean(rut);

    let t = parseInt(rut.slice(0, -1), 10);
    let m = 0;
    let s = 1;

    while (t > 0) {
        s = (s + (t % 10) * (9 - (m++ % 6))) % 11;
        t = Math.floor(t / 10);
    }

    const v = s > 0 ? "" + (s - 1) : "K";
    return v === rut.slice(-1);
};

const clean = (rut) => {
    return typeof rut === "string"
        ? rut.replace(/^0+|[^0-9kK]+/g, "").toUpperCase()
        : "";
};

export const format = (
    rut,
    options = {
        dots: true,
    }
) => {
    rut = clean(rut);

    let result;
    if (options.dots) {
        result = rut.slice(-4, -1) + "-" + rut.substr(rut.length - 1);
        for (let i = 4; i < rut.length; i += 3) {
            result = rut.slice(-3 - i, -i) + "." + result;
        }
    } else {
        result = rut.slice(0, -1) + "-" + rut.substr(rut.length - 1);
    }

    return result;
};

export const random = (
    options = {
        dots: true,
    }
) => {
    function getRutNumbers(numberOfRuts=10, minValue=1e6, maxValue=4e7) {
        let ruts = [];
        const rutOpts = {
          quantity: numberOfRuts,
          minValue: minValue,
          maxValue: maxValue
        };
    
        function generateRuts() {
          var e, n, r, u, i, t;
          n = [];
          t = 0;
          while (t < rutOpts.quantity) {
            i = getRandomNumber();
            r = 0;
            e = false;
            while (r < n.length) {
              if (n[r].number === i) {
                e = true;
                break
              }
              r++
            }
            if (!e) {
              u = getMod(i);
              n.push({
                number: i,
                mod: u
              })
            }
            t++;
          }
          return ruts = n
        };
      
        function getRandomNumber() {
          var t, e, n, r;
          r = rutOpts.minValue;
          n = rutOpts.maxValue;
          e = parseInt(t);
          if (!e) {
            return Math.floor(Math.random() * (n - r + 1)) + r
          } else {
            return e
          }
        };
      
        function getMod(t) {
          var e, n;
          e = 0;
          n = 1;
          while (t) {
            n = (n + t % 10 * (9 - e++ % 6)) % 11;
            t = Math.floor(t / 10)
          }
          if (n) {
            return n - 1
          } else {
            return "K"
          }
        };
      
      
        let generatedRuts = generateRuts().map(rut => `${rut.number}-${rut.mod}`)
        if (generatedRuts.length === 1) { 
          return generatedRuts[0];
        }
        return generatedRuts;
    }

    return format(getRutNumbers(1), options);
};


export default { random, format, clean, validate };
